import * as React from 'react';
import classNames from 'classnames';
import * as styles from './FoldersListItem.css';

interface IProps {
  selected: boolean;
  image: React.ReactNode;
  title: string;
  description: string;
  onClick(): void;
}

export function FoldersListItem({ selected, image, title, description, onClick }: IProps) {
  return (
    <div className={classNames(styles['container'], selected && styles['container-selected'])} onClick={onClick}>
      <div className={styles['image']}>{image}</div>
      <div className={styles['body']}>
        <div className={styles['title']}>{title}</div>
        <div className={styles['description']}>{description}</div>
      </div>
    </div>
  );
}
